// NFT DAO V2 main contract (NFTDaoV3) — migration + migration stats views
export const NFT_DAO_V2_MAIN_ABI = [
	{
		inputs: [{ internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' }],
		name: 'migrateFromV2Batch',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function',
	},
	{
		inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
		name: 'migrateFromV2',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function',
	},
	{
		inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
		name: 'getUserMigrationStats',
		outputs: [
			{
				components: [
					{ internalType: 'uint256', name: 'v3NftBalance', type: 'uint256' },
					{ internalType: 'uint256', name: 'legacyStillOnV2', type: 'uint256' },
					{ internalType: 'uint256', name: 'legacyMigratedOwnedOnV3', type: 'uint256' },
					{ internalType: 'uint256', name: 'issueFlags', type: 'uint256' },
					{ internalType: 'uint256[]', name: 'legacyTokenIdsStillOnV2', type: 'uint256[]' },
				],
				name: 'st',
				type: 'tuple',
			},
		],
		stateMutability: 'view',
		type: 'function',
	},
	{
		inputs: [],
		name: 'getGlobalMigrationStats',
		outputs: [
			{
				components: [
					{ internalType: 'uint256', name: 'legacyIdsTotal', type: 'uint256' },
					{ internalType: 'uint256', name: 'migratedCount', type: 'uint256' },
					{ internalType: 'uint256', name: 'pendingCount', type: 'uint256' },
				],
				name: 's',
				type: 'tuple',
			},
		],
		stateMutability: 'view',
		type: 'function',
	},
	{
		inputs: [],
		name: 'legacyV2',
		outputs: [{ internalType: 'address', name: '', type: 'address' }],
		stateMutability: 'view',
		type: 'function',
	},
	{
		inputs: [],
		name: 'legacyMaxTokenId',
		outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
		stateMutability: 'view',
		type: 'function',
	},
] as const;

export interface UserMigrationStats {
	v3NftBalance: bigint;
	legacyStillOnV2: bigint;
	legacyMigratedOwnedOnV3: bigint;
	issueFlags: bigint;
	legacyTokenIdsStillOnV2: readonly bigint[];
}

export interface GlobalMigrationStats {
	legacyIdsTotal: bigint;
	migratedCount: bigint;
	pendingCount: bigint;
}
